import { Controller } from "@hotwired/stimulus"

// Closes Bootstrap dropdowns after Turbo frame updates
export default class extends Controller {
  connect() {
    // Close any open Bootstrap dropdowns when this element connects
    const openDropdowns = this.element.querySelectorAll('.dropdown-menu.show')
    openDropdowns.forEach(menu => {
      menu.classList.remove('show')
      const toggle = menu.previousElementSibling
      if (toggle && toggle.getAttribute('aria-expanded') === 'true') {
        toggle.setAttribute('aria-expanded', 'false')
      }
    })

    // Also close any dropdowns that might be ancestors
    const dropdownParent = this.element.closest('.dropdown')
    if (dropdownParent) {
      const menu = dropdownParent.querySelector('.dropdown-menu.show')
      if (menu) {
        menu.classList.remove('show')
      }
    }
  }
}